import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme'
import { PlayTile } from '@trivie/ui-mobile/components/play-tile'

export interface SurveysTabProps {
  searchTerm?: string
}

export const SurveysTab = observer((props: SurveysTabProps) => {
  const { userStore, surveyStore } = useStores()
  const { user } = userStore
  const { assignedSurveys } = surveyStore
  const { searchTerm } = props

  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 })

  const history = useHistory()

  function useWindowSize() {
    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        })
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => window.removeEventListener('resize', handleResize)
    }, [])
    return windowSize
  }

  useWindowSize()
  function responsiveGrid() {
    if (windowSize.width < 1024) {
      return THINGRID
    } else if (windowSize.width < 1440) {
      return NORMALGRID
    } else {
      return WIDEGRID
    }
  }

  const filteredData = assignedSurveys
    .slice()
    .filter(
      (item) =>
        !searchTerm || item.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
    )

  const goToSurvey = (item) => {
    if (user) {
      if (item.metadata) {
        history.push(
          `/survey/?survey_id=${item.survey_id}&content_user_id=${item.metadata.content_user_id}&subscription_user_id=${item.metadata.subscription_user_id}&path_id=${item.metadata.path_id}&assignment_id=${item.metadata.assignment_id}`,
        )
      }
    }
  }

  return (
    <div style={CONTENT}>
      <div style={responsiveGrid()}>
        {filteredData.map((item, index) => {
          return (
            <PlayTile
              key={`Survey_${item.survey_id}`}
              onPress={() => goToSurvey(item)}
              tile={
                {
                  due_date: item.end_datetime,
                  is_post_test: false,
                  is_pre_test: false,
                  object_id: item.survey_id,
                  metadata: null,
                  object_title: item.title,
                  object_type: 'survey',
                  topic_id: null,
                  topic_image_url: null,
                  topic_title: null,
                  extension: null,
                  subtitleTx: item.is_anonymous ? 'Anonymous Survey' : 'Survey.survey',
                } as any
              }
              titlePadding={40}
              locale={user?.language ?? 'en'}
              style={{ flex: 1, width: '100%', minWidth: 0 }}
              imageStyle={{ width: '100%' }}
            />
          )
        })}
      </div>
    </div>
  )
})

/**
 * Styling
 */
const CONTENT: React.CSSProperties = {
  backgroundColor: color.white,
  height: '100%',
}
const WIDEGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const NORMALGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const THINGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
